import type { Editor } from '@tiptap/core';
import { useEffect, useState } from 'react';

/** DOM des Editors, falls er eingehängt ist (vorher wirft `editor.view.dom`). */
export function editorDom(editor: Editor): HTMLElement | null {
  if (editor.isDestroyed) return null;
  try {
    return editor.view.dom;
  } catch {
    return null;
  }
}

/**
 * DOM des Editors, sobald TipTap ihn eingehängt hat. Das geschieht erst mit `EditorContent` und nicht immer vor den Effekten der
 * Nachbarn – wer Lagen misst oder Ereignisse am DOM abonniert, wartet darauf (Ereignisse `mount`/`unmount`).
 */
export function useEditorDom(editor: Editor): HTMLElement | null {
  const [dom, setDom] = useState<HTMLElement | null>(() => editorDom(editor));
  useEffect(() => {
    const mounted = (): void => setDom(editorDom(editor));
    const unmounted = (): void => setDom(null);
    mounted();
    editor.on('mount', mounted);
    editor.on('unmount', unmounted);
    return () => {
      editor.off('mount', mounted);
      editor.off('unmount', unmounted);
    };
  }, [editor]);
  return dom;
}
